import { ChargeBasicFee } from "@/models/chargeBasicFee";
import { ChargeFeeMonthlySurchargesUnitPrice } from "@/models/chargeFeeMonthlySurchargesUnitPrice";
import { ChargeFeeTariffPeriod } from "@/models/chargeFeeTariffPeriod";
import { MonthlyBillingNotesOutput } from "@/models/monthlyBillingNotes";
import { AxiosResponse } from "axios";
import { httpClient } from "./API";

export const getBasicFeeAPI = async (
  officeId: number,
  targetMonth: string
): Promise<AxiosResponse<ChargeBasicFee>> => {
  return httpClient.get("/core/internal/calgary/contractFee/basicFee/", {
    params: {
      officeId,
      targetMonth,
    },
  });
};

export const getChargeFeeTariffPeriodAPI = async (
  officeId: number,
  targetMonth: string
): Promise<AxiosResponse<ChargeFeeTariffPeriod>> => {
  return httpClient.get("/core/internal/calgary/contractFee/period/", {
    params: {
      officeId,
      targetMonth,
    },
  });
};

export const getChargeFeeMonthlySurchargesUnitPriceAPI = async (
  officeId: number,
  targetMonth: string
): Promise<AxiosResponse<ChargeFeeMonthlySurchargesUnitPrice>> => {
  return httpClient.get("/core/internal/calgary/contractFee/surcharge/", {
    params: {
      officeId,
      targetMonth,
    },
  });
};

export const getContractFeeMessageAPI = async (
  targetMonth: string
): Promise<AxiosResponse<MonthlyBillingNotesOutput>> => {
  return httpClient.get("/core/internal/calgary/contractFee/message/", {
    params: {
      targetMonth,
    },
  });
};
